/**
 * @group Project
 * @summary Project year
 * 
 * @remarks
 * This constant contains the current year used for copyright notices
 * and other time-sensitive project information.
 * 
 * @example
 * ```typescript
 * import { PROJECT_YEAR } from '@shared/constants';
 * 
 * const copyrightText = `© ${PROJECT_YEAR} All rights reserved`;
 * ```
 */
export const PROJECT_YEAR = new Date().getFullYear(); 